var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 98,
	"./layouts/card/style.module.scss": 98,
	"./layouts/components/breadcrumbs": 122,
	"./layouts/components/breadcrumbs/": 122,
	"./layouts/components/breadcrumbs/index": 122,
	"./layouts/components/breadcrumbs/index.tsx": 122,
	"./layouts/components/breadcrumbs/style.module": 174,
	"./layouts/components/breadcrumbs/style.module.scss": 174,
	"./layouts/components/container": 42,
	"./layouts/components/container/": 42,
	"./layouts/components/container/index": 42,
	"./layouts/components/container/index.tsx": 42,
	"./layouts/components/container/style.module": 124,
	"./layouts/components/container/style.module.scss": 124,
	"./layouts/components/footer": 123,
	"./layouts/components/footer/": 123,
	"./layouts/components/footer/index": 123,
	"./layouts/components/footer/index.tsx": 123,
	"./layouts/components/footer/style.module": 87,
	"./layouts/components/footer/style.module.scss": 87,
	"./layouts/components/loading_indicator": 60,
	"./layouts/components/loading_indicator/": 60,
	"./layouts/components/loading_indicator/index": 60,
	"./layouts/components/loading_indicator/index.tsx": 60,
	"./layouts/components/nav_bar": 97,
	"./layouts/components/nav_bar/": 97,
	"./layouts/components/nav_bar/index": 97,
	"./layouts/components/nav_bar/index.tsx": 97,
	"./layouts/components/nav_bar/standalone": 327,
	"./layouts/components/nav_bar/standalone.tsx": 327,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 86,
	"./layouts/components/notice_banner/": 86,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 175,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 175,
	"./layouts/components/notice_banner/index": 86,
	"./layouts/components/notice_banner/index.tsx": 86,
	"./layouts/components/notice_banner/standalone": 328,
	"./layouts/components/notice_banner/standalone.tsx": 328,
	"./layouts/components/notice_banner/style.module": 176,
	"./layouts/components/notice_banner/style.module.scss": 176,
	"./layouts/page": 94,
	"./layouts/page/": 94,
	"./layouts/page/index": 94,
	"./layouts/page/index.tsx": 94,
	"./layouts/page/style.module": 88,
	"./layouts/page/style.module.scss": 88,
	"./layouts/types": 329,
	"./layouts/types.ts": 329,
	"./marketing/pages/home/toefl": 1619,
	"./marketing/pages/home/toefl/": 1619,
	"./marketing/pages/home/toefl/index": 1619,
	"./marketing/pages/home/toefl/index.tsx": 1619,
	"./marketing/pages/home/toefl/sections/ai": 1228,
	"./marketing/pages/home/toefl/sections/ai/": 1228,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1913,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1913,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1914,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1914,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1915,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1915,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1916,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1916,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1917,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1917,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1918,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1918,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1919,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1919,
	"./marketing/pages/home/toefl/sections/ai/index": 1228,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1228,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1920,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1920,
	"./marketing/pages/home/toefl/sections/apps": 1229,
	"./marketing/pages/home/toefl/sections/apps/": 1229,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1921,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1921,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1922,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1922,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1923,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1923,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1924,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1924,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1925,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1925,
	"./marketing/pages/home/toefl/sections/apps/index": 1229,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1229,
	"./marketing/pages/home/toefl/sections/features": 1230,
	"./marketing/pages/home/toefl/sections/features/": 1230,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1926,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1926,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1927,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1927,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1928,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1928,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1929,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1929,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1930,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1930,
	"./marketing/pages/home/toefl/sections/features/index": 1230,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1230,
	"./marketing/pages/home/toefl/sections/official_questions": 1234,
	"./marketing/pages/home/toefl/sections/official_questions/": 1234,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1939,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1939,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1234,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1234,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 764,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 764,
	"./marketing/pages/home/toefl/sections/value_props": 1231,
	"./marketing/pages/home/toefl/sections/value_props/": 1231,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1931,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1931,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1932,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1932,
	"./marketing/pages/home/toefl/sections/value_props/index": 1231,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1231,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2318,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2318,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1232,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1232,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1933,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1933,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1934,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1934,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1935,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1935,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1936,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1936,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1937,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1937,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1232,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1232,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 763,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 763,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1233,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1233,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1938,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1938,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1233,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1233,
	"./marketing/pages/home/toefl/style.module": 1940,
	"./marketing/pages/home/toefl/style.module.scss": 1940,
	"./marketing/pages/plans/toefl": 1620,
	"./marketing/pages/plans/toefl/": 1620,
	"./marketing/pages/plans/toefl/index": 1620,
	"./marketing/pages/plans/toefl/index.tsx": 1620,
	"./marketing/pages/plans/toefl/sections/testimonials": 1235,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1235,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1941,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1941,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1942,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1942,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1235,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2661;